import { render, staticRenderFns } from "./CountdownTimer.vue?vue&type=template&id=1d55dd56&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55dd56",
  null
  
)

export default component.exports